import {
  LitElement,
  html,
  nothing,
} from '@lit'
import { t } from '@nova/utils'

class NovaCustomCalculatorPreview extends LitElement {
  static properties = {
    shape: { type: String, attribute: 'shape' },
    inchW: { type: Number, attribute: 'inch-w' },
    inchH: { type: Number, attribute: 'inch-h' },
    seamWidth: { type: Number, attribute: 'seam-width' },
  }

  connectedCallback() {
    super.connectedCallback()

    document.addEventListener(
      'nova:product:render-custom-calculator-preview',
      this._handlePreviewUpdate,
    )
  }

  disconnectedCallback() {
    super.disconnectedCallback()

    document.removeEventListener(
      'nova:product:render-custom-calculator-preview',
      this._handlePreviewUpdate,
    )
  }

  _handlePreviewUpdate = (event) => {
    const shapeElemValue = document.querySelector('[name="shape"]:checked')?.value || 'rectangle'
    if (shapeElemValue) {
      this.inchW = event.detail.w
      this.inchH = event.detail.h
      this.shape = shapeElemValue
      this.ratio = this.inchW / this.inchH
      this.onPreviewPanel()
      this.requestUpdate()
    }
  }

  firstUpdated() {
    this.initialize()
  }

  onPreviewPanel() {
    this.previewWidth = `${this.inchW}${t('products.custom_calculator.units.in')}`
    this.previewLength = `${this.inchH}${t('products.custom_calculator.units.in')}`
  }

  initialize() {
    this.inchW = 0
    this.inchH = 0
    this.ratio = 0
    this.previewWidth = ''
    this.previewLength = ''
  }

  renderPreviewPanel() {
    let previewShape = ''
    if (this.shape === 'round')
      previewShape = 'preview-panel-round'
    else if (this.shape === 'oval')
      previewShape = 'preview-panel-oval'

    return html`
      <div part="preview-panel ${previewShape}" style="aspect-ratio: ${this.ratio}">
        ${
          this.inchW >= this.seamWidth && previewShape === ''
            ? html`<div part="preview-panel-line"></div>`
            : nothing
        }
      </div>
    `
  }

  renderPreview() {
    switch (this.shape) {
      case 'rectangle':
      case 'runner':
      case 'square':
      case 'special-shape':
      case 'oval':
        return html`
          <div class="" slot="base" part="container">
            <div part="block">
              <div part="label label-width">${this.previewWidth}</div>
              <div part="label label-length">${this.previewLength}</div>
              ${this.renderPreviewPanel()}
            </div>
          </div>
        `
      case 'round':
        return html`
          <div class="" slot="base" part="container">
            <div part="block">
              <div part="label label-radius">${this.previewWidth}</div>
              ${this.renderPreviewPanel()}
            </div>
          </div>
        `
      default:
        break
    }

    return nothing
  }

  render() {
    if (this.inchW && this.inchH) {
      return html`
        <div part="base">
          <slot name="base"></slot>
          ${this.renderPreview()}
        </div>
      `
    }
    return nothing
  }
}

if (typeof customElements.get('nova-custom-calculator-preview') === 'undefined') {
  customElements.define('nova-custom-calculator-preview', NovaCustomCalculatorPreview)
}
